import { render, staticRenderFns } from "./PatientMeasurementChart.vue?vue&type=template&id=5373f47e&scoped=true&"
import script from "./PatientMeasurementChart.vue?vue&type=script&lang=js&"
export * from "./PatientMeasurementChart.vue?vue&type=script&lang=js&"
import style0 from "./PatientMeasurementChart.vue?vue&type=style&index=0&id=5373f47e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5373f47e",
  null
  
)

export default component.exports